import { render, staticRenderFns } from "./BaseEchart.vue?vue&type=template&id=72b30377"
import script from "./BaseEchart.vue?vue&type=script&lang=js"
export * from "./BaseEchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b30377')) {
      api.createRecord('72b30377', component.options)
    } else {
      api.reload('72b30377', component.options)
    }
    module.hot.accept("./BaseEchart.vue?vue&type=template&id=72b30377", function () {
      api.rerender('72b30377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/endKanbanBoard/components/BaseEchart.vue"
export default component.exports